export const isRepeatTheSame = (label: string, field: string) => (value: string, allValues: object) =>
  allValues[field] && value === allValues[field] ? undefined : label;
